import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const BlogList = () => {
  const blogPosts = [
    {
      id: 1,
      title: "Complete Guide to E-commerce Product Photography 2024",
      excerpt: "Master professional e-commerce photography techniques to boost conversion rates and create bestselling products.",
      image: "https://cloud-image.ullrai.com/q/ecommerce-product-photography/",
      category: "E-commerce",
      readTime: "6 min read",
      date: "2024-03-15",
      content: "This comprehensive guide covers everything you need to know about e-commerce product photography..."
    },
    {
      id: 2,
      title: "Deep Dive into AI Background Removal Technology",
      excerpt: "Explore how AI revolutionizes image processing workflows, making background removal 10x more efficient.",
      image: "https://cloud-image.ullrai.com/q/ai-background-removal/",
      category: "Technology",
      readTime: "4 min read",
      date: "2024-03-10",
      content: "AI-powered background removal has revolutionized the way we process images..."
    },
    {
      id: 3,
      title: "Visual Marketing Secrets for Higher Conversion",
      excerpt: "Professional designers share: How to enhance product competitiveness through quality images.",
      image: "https://cloud-image.ullrai.com/q/visual-marketing-strategy/",
      category: "Marketing",
      readTime: "5 min read",
      date: "2024-03-05",
      content: "Learn the secrets of visual marketing that top designers use to boost conversion rates..."
    }
  ];

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-white py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl font-extrabold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent sm:text-5xl">
              Blog
            </h1>
            <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-500">
              Latest insights, tutorials, and updates from our team
            </p>
          </div>

          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {blogPosts.map((post) => (
              <article
                key={post.id}
                className="bg-blue-50/50 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300"
              >
                <div className="relative">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-48 object-cover aspect-video"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                      {post.category}
                    </span>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="flex items-center text-sm text-gray-500 mb-4">
                    <time dateTime={post.date}>
                      {new Date(post.date).toLocaleDateString('en-US', {
                        month: 'long',
                        day: 'numeric',
                        year: 'numeric'
                      })}
                    </time>
                    <span className="mx-2">•</span>
                    <span>{post.readTime}</span>
                  </div>
                  
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    <a href={`/blog/${post.id}`} className="hover:text-blue-600">
                      {post.title}
                    </a>
                  </h3>
                  
                  <p className="text-gray-600 mb-4">
                    {post.excerpt}
                  </p>
                  
                  <a
                    href={`/blog/${post.id}`}
                    className="text-blue-600 hover:text-blue-500 font-medium inline-flex items-center"
                  >
                    Read More
                    <svg
                      className="ml-2 w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogList;